import React, { useState, useEffect, useRef } from "react";
import IconButton from "@mui/material/IconButton";
import { IoClose } from "react-icons/io5";
import { HiPlus } from "react-icons/hi";
import Button from "@mui/material/Button";
import DownloadCSV from "./QuizModule/DownloadSample.jsx";
// import ColorPopup from "../ColorPopup";
import { ThemeProvider, Tooltip, Box } from "@mui/material";
import DevelopTheme from "../../DevelopTheme.js";
import { Rnd } from "react-rnd";
import CSVUpload from "../csvParser/CsvUpload.js";
import IconSelection from "../../../../IconSelection.jsx";
import LanguageDropdown from "./LanguageDropdownSelector.jsx";
import "./PopupPropertiesMenu.css";
import { MdImage, MdTextFields, MdVideocam, MdVolumeUp } from "react-icons/md";
import { FaHighlighter } from "react-icons/fa";
import QuizModule from "./QuizModule/QuizModule";
import ItemContainer from "./ItemContainer";
import CrudQuizComponent from "../quizDevelopment/CrudQuizComponent.jsx";
function PopupPropertiesMenu({
  bookId,
  target, // the selected popup trigger whose properties are to be changed
  propertiesMenu,
  setPropertiesMenu,
  setListening, // for toggling events on the icons on the page, when the menu is opened / closed
  updateTriggerProps,
  deleteObject,
  updateTriggerDisplay,
  quizData,
  handleSaveButton,
}) {
  const [newTitle, setNewTitle] = useState(target.title || { en: "" });
  const [newTitleAudioClip, setNewTitleAudioClip] = useState(
    target.titleAudio || null
  );
  const [languageSelectionMenu, setLanguageSelectionMenu] = useState(
    target.languageSelectionMenu || false
  );
  const [onPageShortAnswerDetails, setOnPageShortAnswerDetails] = useState(
    target.onPageShortAnswerDetails || false
  );
  const [hasUnsavedQuizChanges, setHasUnsavedQuizChanges] = useState(false);

  const [newScale, setNewScale] = useState(target.scale);
  const [newType, setNewType] = useState(target.type);
  // const [colorPickerVisible, setColorPickerVisible] = useState(false);
  // const [previewColor, setPreviewColor] = useState(target.fill);
  const [localItems, setLocalItems] = useState(target.items || []);
  const [editing, setEditing] = useState(false);
  const contentManagerRef = useRef();
  const svgUrlRef = useRef();
  const svgUrlAltRef = useRef(null);
  const [iconUrl, setIconUrl] = useState(
    target.iconUrl ||
      "https://d9fedpdsh4r16.cloudfront.net/misc/icon/icon-neutral.svg"
  );
  const [iconUrlAlt, setIconUrlAlt] = useState({});
  const [currentTab, setCurrentTab] = useState("appearance");
  const [choosingNewItemType, setChoosingNewItemType] = useState(false);
  const [isQuiz, setIsQuiz] = useState(target.isQuiz || false);
  const [localQuiz, setLocalQuiz] = useState(target.quizDetails);
  const [selection, setSelection] = useState("");
  const [chosenLang, setChosenLang] = useState({
    code: "en",
    name: "English",
    native: "English",
  });
  const [showBox, setShowBox] = useState(false);

  const languages = require("../../../../../langs.json");

  useEffect(() => {
    console.log("showing properties of:", target);
    reassignQuizQuestionIds(); // forced fix for weird glitch involving deleting a question then cancelling changes
  }, []);

  useEffect(() => {
    console.log("🚀 ~ target:", target);
  }, [target]);

  function reassignQuizQuestionIds() {
    let temp = target.quizDetails || {};
    if (temp.questions?.length) {
      let { questions } = temp;
      questions.forEach((q, i) => (q.id = i));
      temp.questions = questions;
    }
    setLocalQuiz(temp);
  }

  useEffect(() => {
    if (svgUrlAltRef.current)
      svgUrlAltRef.current.value = iconUrlAlt[chosenLang.code] || "";
    updateTriggerDisplay(target, {
      url: iconUrlAlt[chosenLang.code] || iconUrl,
    });
  }, [chosenLang]);
  useEffect(() => {
    if (target.languageSelectionMenu) {
      setLanguageSelectionMenu(target.languageSelectionMenu);
    }
  }, [target]);
  useEffect(() => {
    if (target.onPageShortAnswerDetails) {
      setOnPageShortAnswerDetails(target.onPageShortAnswerDetails);
    }
  }, [target]);
  function changeLanguage(name) {
    let newLang = languages.find((lang) => lang.name === name);
    setChosenLang(newLang);
  }

  function changeTitle(passedTitle) {
    let temp = newTitle;
    if (passedTitle) {
      temp[chosenLang.code] = passedTitle;
    } else {
      delete temp[chosenLang.code];
    }
    setNewTitle({ ...temp });
  }

  function changeTitleAudioLink(passedLink) {
    let temp = newTitleAudioClip ?? {};
    temp[chosenLang.code] = passedLink;
    setNewTitleAudioClip({ ...temp });
  }

  function loadIcon() {
    const url = svgUrlRef.current.value;

    if (url === "") {
      setIconUrl(null);
      updateTriggerDisplay(target, { url: null });
    } else {
      setIconUrl(url);
      updateTriggerDisplay(target, { url: url });
    }
  }

  function loadAltIcon() {
    const url = svgUrlAltRef.current.value;

    if (url === "") {
      let temp = iconUrlAlt;
      temp[chosenLang.code] = null;
      setIconUrlAlt(temp);
      updateTriggerDisplay(target, { url: null });
    } else {
      let temp = iconUrlAlt;
      temp[chosenLang.code] = url;
      setIconUrlAlt(temp);
      updateTriggerDisplay(target, { url: url });
    }
  }

  const changeScale = (e) => {
    updateTriggerDisplay(target, {
      scale: e.target.value,
      url: svgUrlRef.current.value,
    });
    setNewScale(e.target.value);
  };

  // scroll item type options into view
  useEffect(() => {
    autoScrollContainer();
  }, [choosingNewItemType]);

  function autoScrollContainer() {
    let scrollHeight, height;
    if (contentManagerRef.current) {
      scrollHeight = contentManagerRef.current.scrollHeight;
      height = contentManagerRef.current.getBoundingClientRect().height;
    }
    if (scrollHeight && height)
      contentManagerRef.current.scrollTo({
        top: scrollHeight - height,
        left: 0,
        behavior: "smooth",
      });
  }

  function addItem(type, keepOpen) {
    if (!keepOpen) setChoosingNewItemType(false);
    let temp = localItems.slice();
    temp.push({
      id: temp.length,
      type: type,
      content: { en: "" },
      audioClip: {},
    });
    setLocalItems(temp);
    autoScrollContainer();
  }

  function deleteItem(item) {
    let temp = localItems.filter((i) => i.id !== item.id);
    reassignIDs(temp);
  }

  function updateItem({ id, content, audioClip, description, options }) {
    setLocalItems(
      localItems.map((i) => {
        if (i.id === id) {
          return {
            ...i,
            content,
            audioClip,
            ...(description && { description }),
            ...(options && { options }),
          };
        } else return i;
      })
    );
  }

  function reassignIDs(temp) {
    temp.forEach((item, i) => (item.id = i));
    setLocalItems(temp);
  }

  function shiftItemUp(index) {
    let temp = localItems.slice();
    [temp[index], temp[index - 1]] = [temp[index - 1], temp[index]]; // ES6 shortcut for swapping array items
    reassignIDs(temp);
  }

  function shiftItemDown(index) {
    let temp = localItems.slice();
    [temp[index], temp[index + 1]] = [temp[index + 1], temp[index]]; // ES6 shortcut for swapping array items
    reassignIDs(temp);
  }

  const handleApplyChanges = ({ csvData }) => {
    setListening(true);
    if (csvData) {
      updateTriggerProps(csvData);
    } else {
      updateTriggerProps({
        ...target,
        title: newTitle,
        titleAudio: newTitleAudioClip,
        isQuiz: isQuiz,
        quizDetails: localQuiz,
        iconUrl: iconUrl,
        type: newType,
        scale: newScale,
        onPageShortAnswerDetails: onPageShortAnswerDetails,
        languageSelectionMenu: languageSelectionMenu,
        // fill: previewColor,
        items: localItems,
      });
    }

    setPropertiesMenu({
      ...propertiesMenu,
      visible: false,
    });
  };

  function handleCancelChanges() {
    updateTriggerDisplay(target, { scale: target.scale, url: target.iconUrl });
    setListening(true);
    setPropertiesMenu({
      ...propertiesMenu,
      visible: false,
    });
  }

  useEffect(() => {
    updateTriggerProps({
      ...target,
      languageSelectionMenu: languageSelectionMenu,
    });
  }, [languageSelectionMenu]);

  useEffect(() => {
    updateTriggerProps({
      ...target,
      onPageShortAnswerDetails: onPageShortAnswerDetails,
    });
  }, [onPageShortAnswerDetails]);

  useEffect(() => {
    // Check if the ref is attached to a DOM element before using it
    if (svgUrlAltRef.current) {
      svgUrlAltRef.current.value = selection;
    }
  }, [selection]);
  const handleClose = () => {
    if (hasUnsavedQuizChanges) {
      if (
        window.confirm(
          "You may have unsaved changes in the quiz. Are you sure you want to close the properties menu?"
        )
      ) {
        setListening(true);
        setPropertiesMenu({
          ...propertiesMenu,
          visible: false,
        });
      }
    } else {
      setListening(true);
      setPropertiesMenu({
        ...propertiesMenu,
        visible: false,
      });
    }
  };
  return (
    <Rnd
      className={"pip"}
      bounds="window"
      resizable={"true"}
      cancel={".nodrag"}
      enableResizing={true}
      // bounds="parent"
      style={{ zIndex: 1000 }}
      default={{
        x: propertiesMenu.x,
        y: propertiesMenu.y,
      }}
    >
      <ThemeProvider theme={DevelopTheme}>
        <div className="popup-properties-menu__wrapper">
          <div className="popup-properties-menu__title-container">
            Popup properties
            <div className="popup-properties__close-button">
              <IconButton
                className="nodrag"
                id="closeButton"
                onClick={handleClose}
              >
                <IoClose />
              </IconButton>
            </div>
          </div>
          <div className="popup-properties__tab-container nodrag">
            <div>
              <div
                className={`popup-properties__tab-label ${
                  currentTab === "appearance" ? "selected" : ""
                }`}
                onClick={() => {
                  setCurrentTab("appearance");
                }}
              >
                <span>Appearance</span>
              </div>
              <div
                className={`popup-properties__tab-label ${
                  currentTab === "content" ? "selected" : ""
                }`}
                onClick={() => {
                  setCurrentTab("content");
                }}
              >
                <span>Content</span>
              </div>
              <div
                className={`popup-properties__tab-label ${
                  currentTab === "code" ? "selected" : ""
                }`}
                onClick={() => {
                  setCurrentTab("code");
                }}
              >
                <span>&lt; /&gt;</span>
              </div>
            </div>
            <LanguageDropdown
              languages={languages}
              chosenLang={chosenLang}
              changeLanguage={changeLanguage}
              editing={editing}
            />
          </div>
          <div className="popup-properties__body nodrag">
            {currentTab === "appearance" && (
              <>
                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="start"
                  alignItems="center"
                  padding={2}
                >
                  <span style={{ marginRight: "1rem" }}>Language Button?</span>
                  <input
                    type="checkbox"
                    checked={languageSelectionMenu}
                    onChange={() => {
                      setLanguageSelectionMenu(!languageSelectionMenu);
                    }}
                  />{" "}
                </Box>
                {/* <Button onClick={handleToggleShowShortAnswerBox}>
                  <span style={{ color: "black" }}>
                    {" "}
                    {showBox ? "Hide" : "Show"} Short Answer Box
                  </span>
                </Button> */}
                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="start"
                  alignItems="center"
                  padding={2}
                >
                  <span style={{ marginRight: "1rem" }}>
                    On page short answer Rect?
                  </span>
                  <input
                    type="checkbox"
                    checked={onPageShortAnswerDetails}
                    onChange={() => {
                      setOnPageShortAnswerDetails(!onPageShortAnswerDetails);
                    }}
                  />{" "}
                </Box>
                {/* {showBox && (
                  <Box display="flex" justifyContent="start" padding={2}>
                    <span style={{ marginRight: "1rem" }}>
                      On page short answer question
                    </span>
                    <input
                      type="text"
                      value={onPageShortAnswerDetails.question}
                      onChange={handleInputChange}
                    />
                  </Box>
                )} */}

                <div className="popup-properties__property-container" id="type">
                  <p className="popup-properties__property-name">
                    Trigger type
                  </p>
                  <div style={{ display: "flex", gap: "1rem" }}>
                    <Button
                      size="small"
                      color={newType === "icon" ? "blueButton" : "cancelButton"}
                      variant={newType === "icon" ? "contained" : "outlined"}
                      onClick={() => {
                        setNewType("icon");
                      }}
                    >
                      Icon
                    </Button>
                    <Button
                      size="small"
                      color={newType === "rect" ? "blueButton" : "cancelButton"}
                      variant={newType === "rect" ? "contained" : "outlined"}
                      onClick={() => {
                        setNewType("rect");
                      }}
                    >
                      Rectangle
                    </Button>
                  </div>
                </div>
                {newType === "icon" ? (
                  <>
                    <div
                      className="popup-properties__property-container"
                      id="icon"
                    >
                      <div className="popup-properties__property-options">
                        <div style={{ width: "100%" }}>
                          <label
                            style={{ margin: "0 0 0.25rem 0" }}
                            htmlFor="svgLink"
                          >
                            <span className="popup-properties__property-name">
                              Link to .svg
                            </span>
                            <span
                              style={{
                                fontSize: "0.75rem",
                                marginLeft: "1rem",
                                opacity: 0.5,
                              }}
                            >
                              e.g. https://website.com/../cool-icon.svg
                            </span>
                          </label>
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                            }}
                          >
                            <input
                              ref={svgUrlRef}
                              id="svgLink"
                              type="text"
                              defaultValue={selection || target.iconUrl}
                              style={{ fontSize: "0.75rem", flexGrow: 1 }}
                              value={selection || target.iconUrl}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") loadIcon();
                              }}
                            />
                            <button
                              className="loadSvgButton"
                              onClick={loadIcon}
                            >
                              <svg
                                viewBox="0 0 512 512"
                                fill="none"
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit="10"
                                strokeWidth="80"
                                height="1rem"
                                width="1rem"
                                style={{ transform: "translateY(-0.2rem)" }}
                              >
                                <path d="M416 128L192 384l-96-96" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {chosenLang.code !== "en" && (
                      <div
                        className="popup-properties__property-container"
                        id="icon"
                      >
                        <div className="popup-properties__property-options">
                          <div style={{ width: "100%" }}>
                            <label
                              style={{ margin: "0 0 0.25rem 0" }}
                              htmlFor="svgLinkAlt"
                            >
                              <span className="popup-properties__property-name">
                                {`Alt link to .svg (${chosenLang.code})`}
                              </span>
                              <span
                                style={{
                                  fontSize: "0.75rem",
                                  marginLeft: "1rem",
                                  opacity: 0.5,
                                }}
                              >
                                (optional)
                              </span>
                            </label>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                gap: "0.5rem",
                              }}
                            >
                              <input
                                ref={svgUrlAltRef}
                                id="svgLinkAlt"
                                type="text"
                                defaultValue={iconUrlAlt[chosenLang.code] || ""}
                                style={{ fontSize: "0.75rem", flexGrow: 1 }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") loadAltIcon();
                                }}
                              />
                              <button
                                className="loadSvgButton"
                                onClick={loadAltIcon}
                              >
                                <svg
                                  viewBox="0 0 512 512"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit="10"
                                  strokeWidth="80"
                                  height="1rem"
                                  width="1rem"
                                  style={{ transform: "translateY(-0.2rem)" }}
                                >
                                  <path d="M416 128L192 384l-96-96" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                        }}
                      >
                        <div
                          className="popup-properties__property-container"
                          style={{ width: "100%" }}
                        >
                          <p className="popup-properties__property-name">
                            Size
                          </p>
                          <div
                            className="popup-properties__property-options"
                            style={{ width: "100%", gap: "0.5rem" }}
                          >
                            <input
                              type="number"
                              min={20}
                              max={500}
                              value={newScale}
                              onChange={changeScale}
                              style={{ width: "4rem" }}
                            />
                            <input
                              type="range"
                              min={20}
                              max={500}
                              step={1}
                              value={newScale}
                              onChange={changeScale}
                              style={{ flexGrow: 1 }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <IconSelection
                      selection={selection}
                      setSelection={setSelection}
                      setIconUrl={setIconUrl}
                      svgUrlAltRef={svgUrlAltRef}
                    />
                  </>
                ) : (
                  <></>
                )}
              </>
            )}
            {currentTab === "content" && (
              <div className="popup-properties__content-tab">
                {quizData ? (
                  <>
                    <CrudQuizComponent
                      quizData={quizData}
                      hasUnsavedQuizChanges={hasUnsavedQuizChanges}
                      setHasUnsavedQuizChanges={setHasUnsavedQuizChanges}
                      lang={chosenLang?.code}
                    />
                  </>
                ) : (
                  <>
                    <div className="popup-properties__content-properties">
                      <DownloadCSV />
                      <CSVUpload
                        bookId={bookId}
                        handleSaveButton={handleSaveButton}
                        target={target}
                        updateTriggerProps={updateTriggerProps}
                        handleApplyChanges={handleApplyChanges}
                      />
                      <label>
                        Window title ({chosenLang.code}):{" "}
                        <input
                          type="text"
                          value={newTitle[chosenLang.code] || ""}
                          onChange={(e) => changeTitle(e.target.value)}
                        />
                      </label>
                      <label>
                        Audio for title ({chosenLang.code}):{" "}
                        <input
                          type="text"
                          value={
                            newTitleAudioClip
                              ? newTitleAudioClip[chosenLang.code]
                              : ""
                          }
                          onChange={(e) => changeTitleAudioLink(e.target.value)}
                        />
                      </label>
                      <div style={{ display: "flex", gap: "1rem" }}>
                        <label id="quiz">
                          Quiz module?
                          <input
                            type="checkbox"
                            checked={isQuiz}
                            onChange={(e) => {
                              setIsQuiz(e.target.checked);
                            }}
                            style={{ marginLeft: "0.5rem" }}
                          />
                        </label>
                      </div>
                    </div>
                    {isQuiz ? (
                      <QuizModule
                        quiz={localQuiz}
                        bookId={bookId}
                        setQuiz={setLocalQuiz}
                        lang={chosenLang}
                      />
                    ) : (
                      <div
                        ref={contentManagerRef}
                        className="popup-properties__content-manager nodrag"
                      >
                        {localItems.map((item, i) => {
                          return (
                            <ItemContainer
                              key={String(item.id + " - " + item.type)}
                              item={item}
                              applyChanges={updateItem}
                              editing={editing}
                              setEditing={setEditing}
                              deleteThis={() => deleteItem(item)}
                              showReorderingArrows={
                                localItems.length > 1 && !editing
                              }
                              canMoveUp={item.id > 0}
                              canMoveDown={item.id < localItems.length - 1}
                              shiftUp={shiftItemUp}
                              shiftDown={shiftItemDown}
                              lang={chosenLang}
                            />
                          );
                        })}
                        {choosingNewItemType ? (
                          <div className="popup-properties__content-type-chooser">
                            <p style={{ margin: 0 }}>Choose type</p>
                            <div className="popup-properties__content-type-chooser__button-row">
                              <Tooltip title="Text">
                                <IconButton
                                  size="large"
                                  color="blueButton"
                                  onClick={(e) =>
                                    addItem("text", e.metaKey || e.ctrlKey)
                                  }
                                >
                                  <MdTextFields />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Image">
                                <IconButton
                                  size="large"
                                  color="blueButton"
                                  onClick={(e) =>
                                    addItem("image", e.metaKey || e.ctrlKey)
                                  }
                                >
                                  <MdImage />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Audio">
                                <IconButton
                                  size="large"
                                  color="blueButton"
                                  onClick={(e) =>
                                    addItem("audio", e.metaKey || e.ctrlKey)
                                  }
                                >
                                  <MdVolumeUp />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Video">
                                <IconButton
                                  size="large"
                                  color="blueButton"
                                  onClick={(e) =>
                                    addItem("video", e.metaKey || e.ctrlKey)
                                  }
                                >
                                  <MdVideocam />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Annotatable image">
                                <IconButton
                                  size="large"
                                  color="blueButton"
                                  onClick={(e) =>
                                    addItem(
                                      "annotation",
                                      e.metaKey || e.ctrlKey
                                    )
                                  }
                                >
                                  <FaHighlighter />
                                </IconButton>
                              </Tooltip>
                              <Button
                                size="small"
                                variant="outlined"
                                color="cancelButton"
                                onClick={() => setChoosingNewItemType(false)}
                              >
                                <span>Cancel</span>
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <Button
                            size="medium"
                            variant="contained"
                            color="blueButton"
                            onClick={() => setChoosingNewItemType(true)}
                            disabled={editing}
                          >
                            <HiPlus fontSize="large" />
                            <span style={{ marginLeft: "0.25rem" }}>
                              New item
                            </span>
                          </Button>
                        )}
                      </div>
                    )}{" "}
                  </>
                )}
              </div>
            )}
            {currentTab === "code" && (
              <>
                <p className="popup-properties__code-disclaimer">
                  Some items aren&apos;t updated until after clicking "Apply".
                </p>
                <div className="popup-properties__code-wrapper">
                  <pre
                    onClick={(e) => {
                      const el = document.createElement("textarea");
                      el.value = JSON.stringify(
                        {
                          ...target,
                          title: newTitle,
                          titleAudio: newTitleAudioClip,
                          scale: newScale,
                          iconUrlAlt: iconUrlAlt,
                          items: localItems,
                        },
                        null,
                        2
                      );
                      document.body.appendChild(el);
                      el.select();
                      document.execCommand("copy");
                      document.body.removeChild(el);
                      alert("Copied to clipboard!");
                    }}
                  >
                    {JSON.stringify(
                      {
                        ...target,
                        title: newTitle,
                        titleAudio: newTitleAudioClip,
                        scale: newScale,
                        iconUrlAlt: iconUrlAlt,
                        items: localItems,
                      },
                      null,
                      2
                    )}
                  </pre>
                </div>
              </>
            )}
          </div>
          {!quizData && (
            <div className="popup-properties__bottom-bar nodrag">
              <Button
                size="small"
                variant="contained"
                color={"redButton"}
                onClick={deleteObject}
              >
                Delete
              </Button>
              <div className="propertiesMenu__cancelApply">
                <Button
                  size="small"
                  color="cancelButton"
                  variant="outlined"
                  onClick={handleCancelChanges}
                >
                  Cancel
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  color="blueButton"
                  onClick={handleApplyChanges}
                >
                  <strong>Apply</strong>
                </Button>
              </div>
            </div>
          )}{" "}
          <div className="popup-properties__bottom-bar nodrag">
            {quizData && (
              <Button
                size="small"
                variant="contained"
                color={"redButton"}
                onClick={deleteObject}
              >
                Delete
              </Button>
            )}
          </div>
          {/* <div className="popup-properties__bottom-bar nodrag">
            {quizData && (
              <Button
                size="small"
                variant="contained"
                color={"redButton"}
                onClick={deleteObject}
              >
                Delete
              </Button>
            )}
          </div> */}
        </div>
        {/* {colorBoxRef.current && (
          <ColorPopup
            open={colorPickerVisible}
            setOpen={setColorPickerVisible}
            anchor={colorBoxRef.current}
            pickerColor={previewColor}
            changePickerColor={changePickerColor}
            pointColorPicker
          />
        )} */}
      </ThemeProvider>
    </Rnd>
  );
}

export default PopupPropertiesMenu;
